module.exports = __webpack_public_path__ + "static/img/king_card_1.a58d0dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/king_card_1.png
// module id = qpze
// module chunks = 0